import { CssBaseline, ThemeProvider } from '@mui/material'
import { ReactNode } from 'react'
import muiTheme from './muiTheme'

export default function MuiThemeProvider({
  children,
  theme,
}: {
  children: ReactNode
  theme?: any
}) {
  return (
    <ThemeProvider theme={theme ?? muiTheme}>
      {children}
      <CssBaseline />
    </ThemeProvider>
  )
}
